import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = import.meta.env.VITE_APP_BASE_URL as string;

// Simple base query without authentication
const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers, { getState, endpoint }) => {
    // Retain only the tenant header if needed
    // Skip setting X-Tenant for specific endpoints
    if (!['getTenantById'].includes(endpoint)) {
      const tenant = JSON.parse(sessionStorage.getItem('CustomerApp-Tenant') || '{}');
      if (tenant && tenant?.id) {
        headers.set('X-Tenant', tenant.id);
      }
    }

    return headers;
  },
});

// Handle API slice with base query
export const apiSlice = createApi({
  baseQuery: baseQuery,
  endpoints: (builder) => ({}),
});

export type ApiSlice = typeof apiSlice;
